/* eslint-disable max-len */
import { useMemo, useState, useEffect, SetStateAction, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { FlexGrow } from "../../components/FlexBox";
import { NullStateText } from "../../components/Text";
import theme from "../../styles/theme";
import axios from "axios";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarOverviewModify from "../../components/PillarOverviewModify";
import PillarNavigator from "../../components/PillarNavigator";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import KnowledgeAreaModify from "../../components/KnowledgeAreaModify";
import KnowledgeTopicModify from "../../components/KnowledgeTopicModify";
import SnackBar from "../../components/SnackBar";
import LoadingSpinner from "../../components/LoadingSpinner";
import { VersionContext } from "../../context/VersionContext";
interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const courseColumns: readonly CourseColumn[] = [
  { id: "title", label: "Course Title", minWidth: 200 },
  {
    id: "number",
    label: "Course Number",
    minWidth: 150,
  },
  { id: "pillar", label: "Pillar", minWidth: 80 },

  {
    id: "competencies",
    label: "Competencies",
    minWidth: 250,
  },
];
function ModifyKnowledgeTopicDetail(this: any) {
  const navigate = useNavigate();
  const { pillarId, subdomainId, knowledgeId, topicId } = useParams();
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [knowledgeTopicDetail, setKnowledgeTopicDetail] = useState<{
    id: string;
    description: string;
    title: string;
  }>({ id: "", description: "", title: "" });
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const { version } = useContext(VersionContext);

  useEffect(() => {
    if (pillarId && subdomainId && knowledgeId && topicId) {
      // fetchSubdomain(pillarId, subdomainId, knowledgeId, topicId)
      fetchTopic(pillarId, subdomainId, knowledgeId, topicId);
    }
  }, []);
  const fetchTopic = (
    pillar_id: string,
    subdomain_id: string,
    knowledge_id: string,
    topic_id: string
  ) => {
    axios
      .get(`/knowledgetopic?area_id=${knowledge_id}&topic_id=${topic_id}`)
      .then((res) => {
        axios
        .get(`/pillar?curriculum_version=${version.version_number}`)
        .then((res1) => {
            axios
              .get(`/subdomain/summary?pillar_id=${pillarId}&curriculum_version=${version.version_number}`)
              .then((res2) => {
                axios
                  .get(
                    `/knowledgearea?subdomain_id=${subdomain_id}&area_id=${knowledge_id}`
                  )
                  .then((res3) => {
                    setKnowledgeTopicDetail(res.data.knowledgetopics[0]);
                    setPillarNavigation({
                      ...pillarNavigation,
                      id: pillar_id,
                      title: res1.data.pillars.find(
                        (v: any) => v.id === pillar_id
                      ).title,
                      subdomains: {
                        ...pillarNavigation.subdomains,
                        id: subdomain_id,
                        title: res2.data.subdomains.find(
                          (v: any) => v.id === subdomainId
                        ).title,
                        knowledge_areas: {
                          ...pillarNavigation.subdomains.knowledge_areas,
                          id: knowledge_id,
                          title: res3.data.knowledgeareas[0].title,
                          knowledge_topics: {
                            ...pillarNavigation.subdomains.knowledge_areas
                              .knowledge_topics,
                            id: res.data.knowledgetopics[0].id,
                            title: res.data.knowledgetopics[0].title,
                          },
                        },
                      },
                    });
                  })
                  .catch(() => {});
              })
              .catch(() => {});
          })
          .catch(() => {});
      })
      .catch(() => {});
  };
  const fetchSubdomain = (
    pillar_id: string,
    subdomain_id: string,
    knowledge_id: string,
    topic_id: string
  ) => {
    setLoading(true);
    axios
    .get(`/pillar?curriculum_version=${version.version_number}`)
    .then((res) => {
        filterData(
          res.data.pillars,
          pillar_id,
          subdomain_id,
          knowledge_id,
          topic_id
        );
      })
      .catch(() => {});
  };
  const filterData = (
    data: any,
    id: string,
    subdomainID: string,
    knowledgeID: string,
    topicID: string
  ) => {
    data.forEach((element: PillarTypeDetail, index: any) => {
      if (element.id === id) {
        element.subdomains.forEach((subdomain: any) => {
          if (subdomain.id === subdomainID) {
            subdomain.knowledge_areas.forEach(
              (knowledge: {
                id: string;
                description: string;
                title: string;
                knowledge_topics: Array<any>;
              }) => {
                if (knowledge.id === knowledgeID) {
                  knowledge.knowledge_topics.forEach((topic) => {
                    if (topic.id === topicID) {
                      setKnowledgeTopicDetail(topic);
                      setPillarNavigation({
                        ...pillarNavigation,
                        code: element.code,
                        description: element.description,
                        graphics: element.graphics,
                        id: element.id,
                        is_core: element.is_core,
                        title: element.title,
                        subdomains: {
                          ...pillarNavigation.subdomains,
                          id: subdomain.id,
                          description: subdomain.description,
                          title: subdomain.title,
                          knowledge_areas: {
                            ...pillarNavigation.subdomains.knowledge_areas,
                            id: knowledge.id,
                            description: knowledge.description,
                            title: knowledge.title,
                            knowledge_topics: {
                              id: topic.id,
                              description: topic.description,
                              title: topic.title,
                            },
                          },
                        },
                      });
                    }
                  });
                }
              }
            );
          }
        });
      }
      setLoading(false);
    });
  };
  const updateKnowledgeData = (data: any) => {
    setLoading(true);
    axios
      .put("/knowledgetopic/update", { ...data, id: topicId })
      .then((res) => {
        setMessage("Updated knowledge topic successfully");
        setIsSnackbarOpen(true);
        fetchSubdomain(
          pillarId || "",
          subdomainId || "",
          knowledgeId || "",
          topicId || ""
        );
        fetchTopic(
          pillarId || "",
          subdomainId || "",
          knowledgeId || "",
          topicId || ""
        );
        setLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to update knowledge topic!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      {knowledgeTopicDetail && knowledgeTopicDetail.id !== "" ? (
        <CustomFlex
          style={{
            minHeight: "inherit",
            height: "100%",
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 0,
          }}
        >
          <FlexGrow
            className="visible-scrollbar"
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 90px)",
              minHeight: "calc(100vh - 90px)",
            }}
          >
            <CustomFlex>
              <FlexGrow>
                <PillarNavigator path={pillarNavigation} />
              </FlexGrow>
            </CustomFlex>
            {loading && <LoadingSpinner />}
            <KnowledgeTopicModify
              knowledgeData={knowledgeTopicDetail}
              goBack={() => {}}
              onSaveComplete={(data) => {
                updateKnowledgeData(data);
              }}
            />
          </FlexGrow>
        </CustomFlex>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
export default ModifyKnowledgeTopicDetail;
